import angular from 'angular';

import { BoxTogglerService } from '../services/box-toggler.service';

interface BoxTogglerScope extends ng.IScope {
  boxContent: string;
  close     : ( skipAnimation ?: boolean ) => void;
  init      : () => void;
  isOpen    : boolean;
  open      : ( skipAnimation ?: boolean ) => void;
  toggle    : () => void;
};

export function BoxTogglerDirective (
  $timeout     : ng.ITimeoutService,
  boxTogglerApi: BoxTogglerService
) : ng.IDirective {

  function link ( scope : BoxTogglerScope, element: ng.IRootElementService) {
    scope.close = function ( skipAnimation = false ) {
      const contentElement = boxTogglerApi.getContentElement(scope.boxContent);

      boxTogglerApi.close(element, contentElement, skipAnimation);
    };

    scope.init = function () {
      element.on('click', scope.toggle);

      scope.isOpen = angular.isUndefined(scope.isOpen)
        ? true
        : scope.isOpen;

      if (scope.isOpen) {
        $timeout(() => scope.open(true));
      }
      else {
        $timeout(() => scope.close(true));
      }
    };

    scope.open = function ( skipAnimation = false ) {
      const contentElement = boxTogglerApi.getContentElement(scope.boxContent);

      boxTogglerApi.open(element, contentElement, skipAnimation);
    };

    scope.toggle = function () {
      scope.isOpen = !scope.isOpen;

      if (!scope.$$phase) {
        scope.$apply();
      }
    };

    scope.$on('$destroy', () => {
      element.off('click', scope.toggle);
    });

    scope.$watch('isOpen', ( newVal : boolean, oldVal : boolean ) => {
      if (newVal !== oldVal) {
        if (newVal) {
          scope.open();
        }
        else {
          scope.close();
        }
      }
    });

    scope.init();
  }

  return {
    link,
    restrict: 'A',
    scope   : {
      boxContent: '@',
      isOpen    : '=?'
    }
  };
};
